import React, { useState, useEffect } from "react";
import Moment from "moment";

// Redux
import { connect } from "react-redux";

import PropTypes from "prop-types";
import genericAction from "@Actions/generic";

// Components
import Text from "@Components/Text";
import { Button, Checkbox, Dropdown, Form, Label, Icon, Grid } from "semantic-ui-react";
import Input from "@Components/Input";
import { dropdownFormat } from "@Utils/formats";
import IKModal from "@Components/IkModal";
import InputFilter from "@Components/InputFilter";

// Lodash
import { isEmpty, map, concat, split, find, isArray, includes } from "lodash";

// Modals
import TextAreaInput from "@Components/TextArea";

// staticData
import {
	contactOption,
	orderByOptionsDetailed,
	orderByOptions,
	orderByOptionsResumidas,
	orderByOptionsHoraUsuarios,
	orderByOptionsHoraGrupos,
	dropdownOptions,
} from "./staticData";

// Styles
import styles from "./styles.module.css";

const ActionUserCrud = ({
	onClose,
	dispatch,
	setPlatformfilters,
	groupsfilters,
	setGroupsfilters,
	tagsSelected,
	setTagsSelected,
	categoriesSelected,
	setCategoriesSelected,
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	contacts,
	setContacts,
	agents,
	setAgents,
	note,
	setNote,
	options,
	setSeletedFilteres,
	seletedFilteres,
	dateField,
	setDateField,
	onApplyFilters,
	channelFilters,
	setChannelFilters,
	channels,
	setTabValue,
	stateValue,
	setStateValue,
	orderBy,
	setOrderBy,
	orderDirection,
	setOrderDirection,
	companyFields,

	selectedFields,
	setSelectedFields,

	listItemsSelected,
	setListItemsSelected,
}) => {
	const [channelfiltersData, setChannelfiltersData] = useState([]);
	const [channelAll, setChannelAll] = useState(false);
	const [groupsAll, setGroupsAll] = useState(false);
	const [groupsData, setGroupsData] = useState([]);
	const [agentsData, setAgentsData] = useState([]);
	const [tagsData, setTagsData] = useState([]);
	const [categoriesData, setCategoriesData] = useState([]);
	const [cleaned, setCleaned] = useState(false);
	const [filtersByReportType, setFiltersByReportType] = useState({});
	const [selectedFilterTemp, setSelectedFilterTemp] = useState(seletedFilteres || "Detalladas");
	const [selectedFieldsTemp, setSelectedFieldsTemp] = useState(selectedFields || []);
	const [listItemsSelectedTemp, setListItemsSelectedTemp] = useState(listItemsSelected || []);
	const [tempOrderBy, setTempOrderBy] = useState(orderBy || dateField || "closeDate");
	const [tempOrderDirection, setTempOrderDirection] = useState(orderDirection || "desc");

	const [errors, setErrors] = useState({ platformfilters: "", selected: "" });

	const [fields, setFields] = useState({ normalFields: [], listFields: [] });

	const orderDirectionOptions = (find(orderByOptions, { key: "orderDirection" }) || {}).options || [];

	// Se eliminó el useEffect que forzaba "tempOrderBy" a cambiar cada vez que "dateField" se actualizaba,
	// lo que causaba que la configuración guardada se perdiera al abrir el modal.

	useEffect(() => {
		(async () => {
			// Lanzar todas las promesas en paralelo
			const usersPromise = dispatch(genericAction({ method: "get", route: "users/all" }));
			const tagsPromise = dispatch(genericAction({ method: "get", route: "tags/all" }));
			const groupPromise = dispatch(genericAction({ method: "get", route: "groups/all" }));
			const categoriesPromise = dispatch(genericAction({ method: "get", route: "category/all" }));

			const [usersResponse, tagsResponse, groupResponse, categoriesResponse] = await Promise.all([
				usersPromise,
				tagsPromise,
				groupPromise,
				categoriesPromise,
			]);

			const platoformsMapped = map(channels, (item) => {
				return {
					key: item.id,
					text: item.label.toLowerCase(),
					value: item.id,
				};
			});

			const groupsMapped = dropdownFormat(groupResponse, "name", "id");
			groupsMapped.unshift({ key: "*", text: "Sin grupo", value: "*" });

			setChannelfiltersData(platoformsMapped);
			setGroupsData(groupsMapped);

			const agentsMapped = dropdownFormat(usersResponse, "user.fullName", "userId");
			const tagsMapped = map(tagsResponse, (item) => {
				return {
					key: item.id,
					text: item.name,
					value: item.id,
					categoryId: item.categoryId,
				};
			});
			const categoriesMapped = dropdownFormat(categoriesResponse, "name", "id");

			setAgentsData(agentsMapped);
			setTagsData(tagsMapped);
			setCategoriesData(categoriesMapped);
		})();
	}, []);

	useEffect(() => {
		const normalFields = [];
		const listItems = [];

		(companyFields || []).forEach((field) => {
			if (field?.type === "list") {
				const rawItems =
					Array.isArray(field.items) && field.items.length > 0 ? field.items : Array.isArray(field.options) ? field.options : [];

				rawItems.forEach((it, idx) => {
					const text = typeof it === "string" ? it : it.label ?? it.text ?? String(it.value ?? it);
					const value = `${field.label}::${text}`;

					listItems.push({
						key: `${field.label}-${idx}`,
						text,
						value,
						description: field.label,
					});
				});
			} else {
				normalFields.push({ key: field.label, text: field.label, value: field.label });
			}
		});

		setFields({ normalFields, listItems });
	}, [companyFields]);

	const checkAll = (name) => {
		switch (name) {
			case "channelFilters":
				if (!channelAll) {
					const allChannelIds = map(channels, (item) => {
						return item.id;
					});
					setChannelFilters(allChannelIds);
					setChannelAll(true);
				} else {
					setChannelFilters([]);
					setChannelAll(false);
				}
				break;
			case "groupsfilters":
				if (!groupsAll) {
					const allGroupIds = map(groupsData, (item) => {
						return item.value;
					});
					setGroupsfilters(allGroupIds);
					setGroupsAll(true);
				} else {
					setGroupsfilters([]);
					setGroupsAll(false);
				}
				break;
			default:
				break;
		}
	};

	const handleInput = (e) => {
		const { name, value } = e.target;
		if (name === "startDate") {
			setStartDate(value);
		} else {
			setEndDate(value);
		}
	};

	const handleTipyfication = (name, data) => {
		setTagsSelected(data);
	};

	const onFilter = () => {
		const contactId = contacts?.id || null;
		const errorsTest = {};

		const noFieldsSelected =
			isEmpty(agents) &&
			!contactId &&
			isEmpty(groupsfilters) &&
			isEmpty(tagsSelected) &&
			isEmpty(startDate) &&
			isEmpty(endDate) &&
			isEmpty(note) &&
			isEmpty(channelFilters) &&
			isEmpty(selectedFilterTemp);

		const onlyReportType =
			!isEmpty(selectedFilterTemp) &&
			isEmpty(agents) &&
			!contactId &&
			isEmpty(groupsfilters) &&
			isEmpty(tagsSelected) &&
			isEmpty(startDate) &&
			isEmpty(endDate) &&
			isEmpty(note) &&
			isEmpty(channelFilters);

		if (noFieldsSelected) {
			errorsTest.selected = "Debe seleccionar mínimo un campo";
			setErrors(errorsTest);
			return;
		}

		if (onlyReportType) {
			errorsTest.selected = "Seleccione al menos otro campo además del tipo de reporte";
			setErrors(errorsTest);
			return;
		}

		if (isEmpty(selectedFilterTemp)) {
			errorsTest.selected = "Debe seleccionar un tipo de reporte";
			setErrors(errorsTest);
			return;
		}

		if (tempOrderBy && !tempOrderDirection) {
			errorsTest.selected = "Si selecciona 'Ordenar por', también debe seleccionar 'Ascendente' o 'Descendente'.";
			setErrors(errorsTest);
			return;
		}

		setErrors({});
		const filters = {};

		if (contactId) filters.contactId = contactId;
		if (!isEmpty(agents)) {
			filters["userId[]"] = concat([], agents);
		}
		if (!isEmpty(groupsfilters)) {
			if (groupsfilters.includes("*")) {
				filters["groupId&*"] = 0;
			} else {
				filters["groupId[]"] = concat([], groupsfilters);
			}
		}

		if (!isEmpty(tagsSelected)) filters.tags = tagsSelected;
		if (!isEmpty(categoriesSelected)) filters["tags.categoryId[]"] = categoriesSelected;
		if (note) filters.text = note;
		if (!isEmpty(channelFilters)) {
			filters["channelId[]"] = concat([], channelFilters);
		}
		if (dateField && (startDate || endDate)) {
			const start = startDate || "";
			const end = endDate || "";
			filters[dateField] = `${start},${end}`;
			if (!["Detalladas", "Resumidas"].includes(selectedFilterTemp)) {
				filters.fieldDate = dateField;
			}
		}

		if (!["Por Días", "Por Mes", "Por Horas"].includes(selectedFilterTemp)) {
			if (tempOrderBy) {
				filters.orderKey = tempOrderBy;
				if (setOrderBy) setOrderBy(tempOrderBy);
			} else if (setOrderBy) setOrderBy("");
			if (tempOrderDirection) {
				filters.orderDir = tempOrderDirection;
				if (setOrderDirection) setOrderDirection(tempOrderDirection);
			} else if (setOrderDirection) setOrderDirection("");
		} else {
			if (setOrderBy) setOrderBy("");
			if (setOrderDirection) setOrderDirection("");
		}

		if (selectedFilterTemp === "Detalladas") {
			if (stateValue) filters.closeState = stateValue;
		}

		setFiltersByReportType((prev) => {
			return {
				...prev,
				[selectedFilterTemp]: filters,
			};
		});

		if (onApplyFilters) {
			setSeletedFilteres(selectedFilterTemp);
			onApplyFilters(filters);
		}
		setSelectedFields(selectedFieldsTemp);
		setListItemsSelected(listItemsSelectedTemp);
		onClose();
	};

	useEffect(() => {
		if (!selectedFilterTemp) {
			setTempOrderBy("");
			setTempOrderDirection("");
			return;
		}
		const filters = filtersByReportType[selectedFilterTemp];
		if (filters) {
			setAgents(filters.userId || []);
			setContacts(filters.contactId ? { id: filters.contactId } : {});
			setGroupsfilters(filters.groups || []);
			setTagsSelected(filters.tags || []);
			setCategoriesSelected(filters["tags.categoryId[]"] || filters.categories || []);
			setNote(filters.text || "");
			setPlatformfilters(filters.platforms || []);
			if (setStateValue) setStateValue(filters.state || "");
			let newDateField = dateField || "closeDate";
			if (filters.createdDate || filters.closeDate) {
				const range = filters.createdDate || filters.closeDate;
				const [start, end] = split(range, ",");
				setStartDate(start);
				setEndDate(end);
				newDateField = filters.createdDate ? "createdDate" : "closeDate";
				setDateField(newDateField);
			}
			setTempOrderBy(filters.orderKey || newDateField);
			setTempOrderDirection(filters.orderDir || "desc");
		}
	}, [selectedFilterTemp]);

	const onChangeDropdown = (value, name) => {
		if (name === "channelFilters") {
			setChannelFilters(value);
			if (channelfiltersData.length === value.length) {
				setChannelAll(true);
			} else {
				setChannelAll(false);
			}
		} else if (name === "groupsfilters") {
			setGroupsfilters(value);
			if (groupsData.length === value.length) {
				setGroupsAll(true);
			} else {
				setGroupsAll(false);
			}
		}
	};

	const onContactsSelect = (item) => {
		setContacts(item);
	};
	const onContactsRemove = () => {
		setContacts({});
	};
	const renderLabelPlatforms = (label) => {
		return {
			color: "blue",
			content: `${label.text}`,
			icon: label.icon,
		};
	};

	const renderLabelDepartments = (label) => {
		return {
			color: "blue",
			content: `${label.text} `,
			icon: "building outline",
		};
	};
	const cleanModal = () => {
		setAgents([]);
		setContacts("");
		setPlatformfilters([]);
		setChannelFilters([]);
		setGroupsfilters([]);
		setTagsSelected([]);
		setCategoriesSelected([]);
		setStartDate(Moment().format("YYYY-MM-DD"));
		setEndDate("");
		setNote("");
		setGroupsAll(false);
		setChannelAll(false);
		setErrors({ platformfilters: "", selected: "" });
		setSeletedFilteres("");
		setSelectedFilterTemp("Detalladas");
		setTempOrderBy(dateField || "closeDate");
		setTempOrderDirection("desc");
		if (setOrderBy) setOrderBy("");
		if (setOrderDirection) setOrderDirection("");
		if (setStateValue) setStateValue("");

		setSelectedFields([]);
		setListItemsSelected([]);

		setCleaned(true);

		setTimeout(() => {
			setCleaned(false);
		}, 2000);
	};

	const handleInputDropdown = (event, { value }) => {
		setTagsSelected(value);
	};

	const handleCategorySelection = (e, { value }) => {
		setCategoriesSelected(value);
		const promoCategory = find(categoriesData, (c) => {
			return c.text.toLowerCase() === "promo";
		});
		if (promoCategory && includes(value, promoCategory.value)) {
			const promoTag = find(isArray(tagsData) ? tagsData : [], (t) => {
				return t.text.toLowerCase() === "promo";
			});
			if (promoTag && (!tagsSelected || !includes(tagsSelected, promoTag.value))) {
				const newTags = [...(tagsSelected || []), promoTag.value];
				handleInputDropdown(e, { name: "tagsSelected", value: newTags });
			}
		}
	};

	const onChangeSelection = (e, { value }) => {
		setSelectedFilterTemp(value);
		if (value === "Resumidas" || value === "Hora/Usuarios" || value === "Hora/Grupos") {
			setTagsSelected([]);
			setNote("");
		}
		if (value !== "Detalladas") {
			setTabValue("");
			setStateValue("");
		}
	};

	// const channelOptions = map(channels, (channel) => {
	// 	return {
	// 		key: channel.id,
	// 		text: channel.label,
	// 		value: channel.id,
	// 		icon: channel.platform?.name?.toLowerCase() || "circle",
	// 	};
	// });

	const getFieldsetClass = (filters, data) => {
		const safeFilters = filters || [];
		const safeData = data || [];
		if (isEmpty(safeFilters) && isEmpty(agents) && isEmpty(tagsSelected)) return "";

		const ratio = safeData.length === 0 ? 0 : safeFilters.length / safeData.length;

		if (ratio > 0.75 || !isEmpty(agents) || !isEmpty(tagsSelected)) return styles.hasMostOptions;
		if (ratio > 0.5) return styles.hasManyOptions;

		return styles.hasOptions;
	};

	const renderLabelChannels = (label) => {
		return {
			color: "blue",
			content: `${label.text}`,
			icon: label.icon,
		};
	};

	const handleOrderByChange = (value) => {
		setTempOrderBy(value);
		if (value === "createdDate" || value === "closeDate") {
			setDateField(value);
		}
	};

	const getOrderByOptions = () => {
		if (selectedFilterTemp === "Resumidas") return orderByOptionsResumidas;
		if (selectedFilterTemp === "Hora/Usuarios") return orderByOptionsHoraUsuarios;
		if (selectedFilterTemp === "Hora/Grupos") return orderByOptionsHoraGrupos;
		return orderByOptionsDetailed;
	};
	const usersHasMostOptions = (() => {
		const safeFilters = agents || [];
		const safeData = agentsData || [];
		const ratio = safeData.length === 0 ? 0 : safeFilters.length / safeData.length;
		return ratio > 0.75 || !isEmpty(agents) || !isEmpty(tagsSelected);
	})();
	const channelsHasMostOptions = (() => {
		const safeFilters = channelFilters || [];
		const safeData = channelfiltersData || [];
		const ratio = safeData.length === 0 ? 0 : safeFilters.length / safeData.length;
		return ratio > 0.75;
	})();
	const groupsHasMostOptions = (() => {
		const safeFilters = groupsfilters || [];
		const safeData = groupsData || [];
		const ratio = safeData.length === 0 ? 0 : safeFilters.length / safeData.length;
		return ratio > 0.75;
	})();

	const combinedOptions = [
		...(fields.normalFields || []).map(({ key, text, value }) => {
			return {
				key,
				text,
				value: `N::${value}`,
			};
		}),
		...(fields.listItems || []).map(({ key, text, value }) => {
			return {
				key,
				text,
				value: `L::${value}`,
			};
		}),
	];

	const renderCombinedLabel = (label) => {
		return { content: label.text };
	};

	const combinedValue = [
		...(selectedFieldsTemp || []).map((v) => {
			return `N::${v}`;
		}),
		...(listItemsSelectedTemp || []).map((label) => {
			const opt = (fields.listItems || []).find((o) => {
				return o.text === label;
			});
			return opt ? `L::${opt.value}` : `L::${label}`;
		}),
	];

	const onChangeCombined = (e, { value = [] }) => {
		const normals = [];
		const listItems = [];
		value.forEach((v) => {
			if (typeof v !== "string") return;
			if (v.startsWith("N::")) {
				normals.push(v.slice(3));
			} else if (v.startsWith("L::")) {
				const rest = v.slice(3);
				const item = rest.includes("::") ? rest.split("::").pop() : rest;
				listItems.push(item);
			}
		});
		setSelectedFieldsTemp(normals);
		setListItemsSelectedTemp(listItems);
	};

	const sortedOptions = [...combinedOptions].sort((a, b) => {
		return a.text.localeCompare(b.text, "es", { sensitivity: "base" });
	});

	return (
		<IKModal
			iconName="filter"
			title="Filtro de Conv. Cerradas"
			onClose={onClose}
			onSuccess={onFilter}
			cancelLabel="Cancelar"
			saveLabel="Filtrar"
			fullHeight
			size="small">
			<Grid className={styles.grid}>
				{!isEmpty(errors.selected) && (
					<div className={styles.center}>
						<Label className={styles.labelError} basic color="red">
							{errors.selected}
						</Label>
					</div>
				)}
				<div className={styles.containerFirst}>
					<fieldset className={styles.fieldset}>
						<legend className={styles.legendWithButton}>
							<span className={styles.legend}>Filtrado</span>
							<div className={styles.clearButtonContainer}>
								<Button icon size="mini" onClick={cleanModal} className={styles.clearButtonInline}>
									<Icon name="trash alternate outline" />
									Limpiar Todo
								</Button>
								{cleaned && <span className={styles.tooltipAbove}>¡Filtros limpiados!</span>}
							</div>
						</legend>

						<div className={styles.dateContent}>
							<div className={styles.dateFieldDate}>
								<div className={styles.userDropdownBlock2}>
									<span className={styles.lookUpLabel}>Tipo de Reporte:</span>
									<Dropdown
										className={styles.filterDropdown}
										placeholder="Selecciona un filtro"
										selection
										options={options}
										value={selectedFilterTemp}
										onChange={onChangeSelection}
									/>
								</div>
								{!["Detalladas", "Resumidas"].includes(selectedFilterTemp) && (
									<div className={styles.userDropdownBlock2}>
										<span className={styles.lookUpLabelSpecial}>Tipo:</span>
										<Dropdown
											className={styles.filterDropdown}
											placeholder="Selecciona el tipo de fecha"
											selection
											options={[
												{ key: "closeDate", text: "F. Cierre", value: "closeDate" },
												{ key: "createdDate", text: "F. Entrada", value: "createdDate" },
											]}
											value={dateField || "closeDate"}
											onChange={(e, { value }) => {
												setDateField(value);
												setTempOrderBy(value);
												setTempOrderDirection("desc");
											}}
										/>
									</div>
								)}
								<div className={styles.flexContainer}>
									<Input
										type="date"
										label="Desde:"
										icon="calendar minus"
										iconPosition="left"
										placeholder="Inicio"
										fluid
										size="mini"
										name="startDate"
										value={startDate}
										max={Moment().format("YYYY-MM-DD")}
										onChange={handleInput}
										className={styles.dateInput}
									/>
									<Input
										type="date"
										label="Hasta:"
										icon="calendar plus"
										iconPosition="left"
										placeholder="Final"
										fluid
										size="mini"
										name="endDate"
										value={endDate}
										min={startDate}
										max={Moment().format("YYYY-MM-DD")}
										onChange={handleInput}
										className={styles.dateInput}
									/>
								</div>
							</div>
						</div>
						{selectedFilterTemp && !["Por Días", "Por Mes", "Por Horas"].includes(selectedFilterTemp) && (
							<div className={styles.containerOptions}>
								<div className={styles.containerOrder}>
									<Text className={styles.textTypificacion}>Ordenar por:</Text>
									<Dropdown
										fluid
										search
										placeholder="Seleccionar"
										options={getOrderByOptions()}
										value={tempOrderBy}
										onChange={(e, { value }) => {
											return handleOrderByChange(value);
										}}
										selection
										clearable
									/>
								</div>
								<div className={styles.containerOrder}>
									<Text className={styles.textTypificacionSpecial}>&nbsp;</Text>
									<Dropdown
										fluid
										search
										placeholder="Seleccionar"
										options={orderDirectionOptions}
										value={tempOrderDirection}
										onChange={(e, { value }) => {
											return setTempOrderDirection(value);
										}}
										selection
										clearable
										error={!!errors.selected && tempOrderBy && !tempOrderDirection}
									/>
								</div>
							</div>
						)}
						{selectedFilterTemp === "Detalladas" && (
							<div className={styles.containerOrder}>
								<Text className={styles.textTypificacion}>Estado:</Text>
								<Dropdown
									fluid
									search
									placeholder="Seleccionar"
									options={find(dropdownOptions, { key: "stateValue" })?.options || []}
									value={stateValue}
									onChange={(e, { value }) => {
										return setStateValue(value);
									}}
									selection
									clearable
								/>
							</div>
						)}
					</fieldset>
					<fieldset className={styles.fieldset}>
						<legend className={styles.legend}>Otros</legend>
						<div className={styles.contactContainer}>
							<div className={styles.lookUpLabel}>Contacto:</div>
							<InputFilter
								contactData={contacts}
								selectedContact={onContactsSelect}
								onEmpty={onContactsRemove}
								url="contacts"
								defaultField="all"
								forceInputValue="name"
								selectTitle="Buscar Contactos"
								tableColumns={contactOption}
							/>
						</div>
						<div className={styles.containerOrder}>
							<Text className={styles.textTypificacion}>Campos Adicionales</Text>
							<Dropdown
								placeholder="Selecciona"
								fluid
								selection
								multiple
								options={sortedOptions}
								value={combinedValue}
								onChange={onChangeCombined}
								renderLabel={renderCombinedLabel}
								search
								clearable
							/>
						</div>
						<div className={styles.userContainerTags}>
							<div
								className={`${styles.userDropdownBlock} ${styles.typification} ${
									selectedFilterTemp === "Resumidas" ? styles.resumidasCompact : ""
								} ${selectedFilterTemp === "Hora/Usuarios" ? styles.resumidasCompact : ""} ${
									selectedFilterTemp === "Hora/Grupos" ? styles.resumidasCompact : ""
								} ${selectedFilterTemp === "Por Días" ? styles.resumidasCompact : ""} ${
									selectedFilterTemp === "Por Horas" ? styles.resumidasCompact : ""
								}`}>
								<Text className={styles.lookUpLabel}>Usuarios:</Text>
								<Dropdown
									fluid
									onChange={(e, { value }) => {
										return setAgents(value);
									}}
									value={agents}
									renderLabel={renderLabelPlatforms}
									multiple
									selection
									search
									clearable
									options={agentsData}
								/>
							</div>
							{selectedFilterTemp === "Detalladas" && (
								<div className={`${styles.userDropdownBlock} ${styles.typification}`}>
									<div className={`${styles.contDiv} ${styles.justifySpaceBetween}`}>
										<Text className={styles.lookUpLabel} style={{ paddingBottom: 0 }}>
											Grupos:
										</Text>
										<div className={styles.flexAlignCent}>
											<Checkbox
												name="groupsAll"
												className={styles.checkBox}
												checked={groupsAll}
												onChange={() => {
													return checkAll("groupsfilters");
												}}
											/>
											<Text className={`${styles.sectionTitleText} ${styles.marginLeft05rem}`}>Todos</Text>
										</div>
									</div>
									<Dropdown
										fluid
										onChange={(e, { value }) => {
											return onChangeDropdown(value, "groupsfilters");
										}}
										placeholder="Seleccionar Grupos"
										multiple
										clearable
										search
										selection
										value={groupsfilters}
										options={groupsData}
										renderLabel={renderLabelDepartments}
									/>
								</div>
							)}
						</div>
						{selectedFilterTemp !== "Resumidas" &&
							selectedFilterTemp !== "Hora/Usuarios" &&
							selectedFilterTemp !== "Hora/Grupos" &&
							selectedFilterTemp !== "Por Días" &&
							selectedFilterTemp !== "Por Horas" && (
								<Form className={styles.typification}>
									<Text className={styles.textTypificacion}>Texto:</Text>
									<div style={{ position: "relative" }}>
										<TextAreaInput
											value={note}
											name="messageArea"
											onChange={(e) => {
												return setNote(e.target.value);
											}}
											className={styles.inputGroupB}
											rows={1}
										/>
									</div>
								</Form>
							)}
					</fieldset>
				</div>
				<div className={styles.filtersContainer}>
					{!isEmpty(channelfiltersData) && (
						<fieldset
							className={`${styles.fieldsetChannel} ${!isEmpty(errors.selected) ? styles.error : ""} ${
								channelsHasMostOptions && usersHasMostOptions ? styles.hasMostOptions : getFieldsetClass(channelFilters, channelfiltersData)
							} ${selectedFilterTemp === "Detalladas" ? styles.matchEtiquetas : ""}`}>
							<legend className={styles.legend}>Canales</legend>
							<div className={styles.section}>
								<div className={styles.contDiv}>
									<Checkbox
										className={styles.checkBox}
										name="channelAll"
										checked={channelAll}
										onChange={() => {
											return checkAll("channelFilters");
										}}
									/>
									{!isEmpty(errors.channelfilters) && (
										<Text className={styles.ErrorChannel} color="red">
											{errors.channelfilters}
										</Text>
									)}
									<Text className={styles.sectionTitleText}>Todos</Text>
								</div>

								<div className={styles.sectionContent}>
									<Dropdown
										fluid
										onChange={(e, { value }) => {
											return onChangeDropdown(value, "channelFilters");
										}}
										value={channelFilters}
										placeholder="Seleccionar"
										multiple
										clearable
										search
										selection
										options={channelfiltersData}
										renderLabel={renderLabelChannels}
										upward
									/>
								</div>
							</div>
						</fieldset>
					)}
					{selectedFilterTemp === "Detalladas" && (
						<fieldset
							className={`${styles.fieldsetGroup} ${!isEmpty(errors.selected) ? styles.error : ""} ${getFieldsetClass(
								tagsSelected,
								tagsData
							)}`}>
							<legend className={styles.legend}>Etiquetas</legend>
							<div className={styles.sectionContent}>
								<div className={`${styles.userDropdownBlock} ${styles.typification}`}>
									<Text className={styles.lookUpLabel}>Por Categoría:</Text>
									<Dropdown
										fluid
										name="categoriesSelected"
										value={categoriesSelected}
										onChange={handleCategorySelection}
										options={categoriesData}
										placeholder="Seleccionar"
										size="mini"
										search
										multiple
										selection
										clearable
										renderLabel={renderLabelPlatforms}
										upward
									/>
								</div>
								<div className={`${styles.userDropdownBlock} ${styles.typification} ${styles.marginTop1rem}`}>
									<Text className={styles.lookUpLabel}>Por Nombre:</Text>
									<Dropdown
										fluid
										name="tagsSelected"
										value={tagsSelected}
										onChange={handleInputDropdown}
										options={
											!isEmpty(categoriesSelected)
												? (isArray(tagsData) ? tagsData : []).filter((tag) => {
														return includes(categoriesSelected, tag.categoryId);
												  })
												: tagsData
										}
										handleSelection={handleTipyfication}
										placeholder="Seleccionar"
										size="mini"
										search
										multiple
										selection
										clearable
										selected
										renderLabel={renderLabelPlatforms}
										upward
									/>
								</div>
							</div>
						</fieldset>
					)}
					{!isEmpty(groupsData) && selectedFilterTemp !== "Detalladas" && (
						<fieldset
							className={`${styles.fieldsetGroup} ${!isEmpty(errors.selected) ? styles.error : ""} ${
								groupsHasMostOptions && usersHasMostOptions ? styles.hasMostOptions : getFieldsetClass(groupsfilters, groupsData)
							}`}>
							<legend className={styles.legend}>Grupos</legend>
							<div className={styles.contDiv}>
								<Checkbox
									name="groupsAll"
									className={styles.checkBox}
									checked={groupsAll}
									onChange={() => {
										return checkAll("groupsfilters");
									}}
								/>
								<Text className={styles.sectionTitleText}>Todos</Text>
							</div>

							<div className={styles.sectionContent}>
								<Dropdown
									fluid
									onChange={(e, { value }) => {
										return onChangeDropdown(value, "groupsfilters");
									}}
									placeholder="Seleccionar"
									multiple
									clearable
									search
									selection
									value={groupsfilters}
									options={groupsData}
									renderLabel={renderLabelDepartments}
									upward
								/>
							</div>
						</fieldset>
					)}
				</div>
			</Grid>
		</IKModal>
	);
};

ActionUserCrud.propTypes = {
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
	setPlatformfilters: PropTypes.func,
	groupsfilters: PropTypes.array,
	setGroupsfilters: PropTypes.func,
	tagsSelected: PropTypes.array,
	setTagsSelected: PropTypes.func,
	categoriesSelected: PropTypes.array,
	setCategoriesSelected: PropTypes.func,
	startDate: PropTypes.string,
	setStartDate: PropTypes.func,
	endDate: PropTypes.string,
	setEndDate: PropTypes.func,
	contacts: PropTypes.object,
	setContacts: PropTypes.func,
	agents: PropTypes.array,
	setAgents: PropTypes.func,
	note: PropTypes.string,
	setNote: PropTypes.func,
	options: PropTypes.array,
	setSeletedFilteres: PropTypes.func,
	seletedFilteres: PropTypes.array,
	dateField: PropTypes.string,
	setDateField: PropTypes.func,
	onApplyFilters: PropTypes.func,
	channelFilters: PropTypes.string,
	setChannelFilters: PropTypes.func,
	channels: PropTypes.object,
	stateValue: PropTypes.string,
	setStateValue: PropTypes.func,
	orderBy: PropTypes.string,
	setOrderBy: PropTypes.func,
	orderDirection: PropTypes.string,
	setOrderDirection: PropTypes.func,
	setTabValue: PropTypes.func,
	companyFields: PropTypes.array,

	selectedFields: PropTypes.array,
	setSelectedFields: PropTypes.func,

	listItemsSelected: PropTypes.array,
	setListItemsSelected: PropTypes.func,
};

function mapStateToProps({ chats, company, user }) {
	return {
		companyFields: company.companyFields || [],
		reply: chats.reply,
		channels: company.channels,
		user,
	};
}

export default connect(mapStateToProps)(ActionUserCrud);
